import React, { useEffect, useState } from "react";
import api from "../api/axios";

function TrialBalance() {
  const [tree, setTree] = useState([]);
  const [totals, setTotals] = useState({ debit: 0, credit: 0 });
  const [loading, setLoading] = useState(true);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10)); // Default to today's date

  const token = localStorage.getItem("accessToken");
  const branch_id = sessionStorage.getItem("selectedContext")
    ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
    : 0;

  /* ===============================
     Fetch Trial Balance
  =============================== */
  const fetchTrialBalance = async () => {
    //if (!fromDate || !toDate) return;
    //if (!toDate) return;

    setLoading(true);
    try {
      const res = await api.get(
        `/reports/trial-balance?branch_id=${branch_id}&from_date=${fromDate}&to_date=${toDate}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setTree(res.data.tree || []);
      setTotals(res.data.totals || { debit: 0, credit: 0 });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Optionally, fetch trial balance on component mount with default dates
    fetchTrialBalance();
  }, []);

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-GB"); // dd/mm/yyyy
    };

    const formatToday = () => {
        const today = new Date();
        return today.toLocaleDateString("en-GB");
    };

    const getReportTitle = () => {
        if (fromDate && toDate) {
            return `Trial Balance (${formatDate(fromDate)} To ${formatDate(toDate)})`;
        }

        if (!fromDate && toDate) {
            return `Trial Balance (Up to ${formatDate(toDate)})`;
        }

        if (fromDate && !toDate) {
            return `Trial Balance (From ${formatDate(fromDate)} To ${formatToday()})`;
        }

        if (!fromDate && !toDate) {
            return `Trial Balance (Up to ${formatToday()})`;
        }

        return "Trial Balance";
    };


  /* ===============================
     Render Group Rows
  =============================== */
  const renderNode = (node, level = 1) => {
    const paddingLeft = `${level * 12}px`;

    /* ================= GROUP ================= */
    if (node.type === "group") {
        return (
        <React.Fragment key={`group-${node.group_id}`}>
            <tr className=""> {/* table-secondary */}
            <td style={{ paddingLeft }} className="fw-bold">
                {node.group_name}
            </td>
            <td></td>
            <td className="text-end fw-bold">
                {node.debit > 0 ? node.debit.toFixed(2) : "0.00"}
            </td>
            <td className="text-end fw-bold">
                {node.credit > 0 ? node.credit.toFixed(2) : "0.00"}
            </td>
            </tr>

            {/* Render children recursively */}
            {node.children?.map((child) =>
            renderNode(child, level + 1)
            )}
        </React.Fragment>
        );
    }

    /* ================= LEDGER ================= */
    if (node.type === "ledger") {
        return (
        <tr key={`ledger-${node.ledger_id}`}>
            <td style={{ paddingLeft }} className="text-muted">
            {node.ledger_code}
            </td>
            <td style={{ paddingLeft }}>
            {node.ledger_name}
            </td>
            <td className="text-end">
            {node.debit > 0 ? node.debit.toFixed(2) : "0.00"}
            </td>
            <td className="text-end">
            {node.credit > 0 ? node.credit.toFixed(2) : "0.00"}
            </td>
        </tr>
        );
    }

    return null;
    };

  return (
    <>
      {/* Page Header */}
      <div className="row mb-3">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Trial Balance</h4>
        </div>
      </div>

      {/* Filters */}
      <div className="row mb-3">
        <div className="col-md-3">
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <button
            className="btn btn-primary"
            onClick={fetchTrialBalance}
          >
            Show
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
                <h6 className="mb-4">{getReportTitle()}</h6>
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-sm">
                    <thead className="table-light">
                      <tr>
                        <th>Account ID</th>
                        <th>Account Name</th>
                        <th className="text-end">Debit</th>
                        <th className="text-end">Credit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tree.length > 0 ? (
                        tree.map((node) => renderNode(node))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No data
                          </td>
                        </tr>
                      )}
                    </tbody>

                    {/* Totals */}
                    <tfoot className=""> {/* table-dark */}
                      <tr>
                        <th>Total</th>
                        <th></th>
                        <th className="text-end">
                          {totals.debit.toFixed(2)}
                        </th>
                        <th className="text-end">
                          {totals.credit.toFixed(2)}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TrialBalance;